/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */
import React from "react";
import { styled, DialogTitle, IconButton, Typography } from "@mui/material";

export const StyledTitleContainer = styled('div')({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '30px'
})

export const StyledOrderTitle = styled(DialogTitle)({
  '&.MuiDialogTitle-root': {
    padding: '0px 24px'
  },
  fontWeight: '600',
  fontSize: '23px',
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  m: 0,
  p: 0,
  marginTop: '5px',
})

export const StyledIconButton = styled(IconButton)({
  position: 'absolute',
  right: '16px',
  cursor: 'pointer',
})

export const StyledOrderSubTitle = styled(Typography)({
  fontWeight: '600',
  fontSize: '18px',
  padding: '0 !important'
})

export const StyledInfoText = styled(Typography)({
  fontSize: '13px',
  padding: '0 !important'
})

export const OrderDetailContainer = styled('div')(({ theme }) =>({
  display: 'grid',
  gridTemplateColumns: '100px 1fr 100px 0.6fr 100px 1fr',
  columnGap: '10px',
  rowGap: '15px',
  marginTop: '15px',

  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '150px 1fr 150px 1fr',
  },

  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '150px 1fr',
  },
}));

export const OrderInformation = ({label, value}) => {
  return (
    <React.Fragment>
      <StyledInfoText sx={{ fontWeight: 600 }}>{label}</StyledInfoText>
      <StyledInfoText
        sx={{
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
          lineHeight: 1.4,
        }}
      >
        {value}
      </StyledInfoText>
    </React.Fragment>
  );
}
